import React from "react";
import Tabs from "@/components/controls/Tabs";
import { IconButton } from "@/components/ui/icon-button";
import { Close } from "@dreamhub/designsystem/icons";
import { cn } from "@/utils/utils";

interface Props {
  value?: boolean | null;
  onChange?: (value: boolean | null) => void;
  /** Already-translated [yes, no] tab labels. */
  options: string[];
  disabled?: boolean;
  enableDelete?: boolean;
  onDelete?: () => void;
}

const booleanToTabValue = (value: boolean | null): string => {
  if (value === true) return "yes";
  if (value === false) return "no";
  return "";
};

const tabValueToBoolean = (value: string): boolean | null => {
  if (value === "yes") return true;
  if (value === "no") return false;
  return null;
};

const YesNoAnswer: React.FC<Props> = ({
  value,
  onChange,
  options,
  disabled = false,
  enableDelete = false,
  onDelete
}) => {
  const boolOrNullValue: boolean | null =
    typeof value === "boolean" || value === null ? value : null;

  const tabOptions = React.useMemo(
    () => ({ yes: options[0], no: options[1] }),
    [options]
  );

  const handleTabValueChange = (newTabValue: string) => {
    const currentTabValue = booleanToTabValue(boolOrNullValue);
    const newAnswer =
      newTabValue === currentTabValue ? null : tabValueToBoolean(newTabValue);
    onChange?.(newAnswer);
  };

  return (
    <div className="flex items-center gap-2">
      <div className={cn({ "pointer-events-none opacity-50": disabled })}>
        <Tabs
          options={tabOptions}
          value={booleanToTabValue(boolOrNullValue)}
          valueSelected={handleTabValueChange}
          size="lg"
          isPositiveNegative={true}
          disabled={disabled}
        />
      </div>
      {enableDelete && (
        <IconButton
          size="xs"
          variant="iconNoBg"
          iconColor="secondary"
          className="transition-all duration-200 ease-in-out opacity-0 group-hover:opacity-100"
          onClick={onDelete}
        >
          <Close />
        </IconButton>
      )}
    </div>
  );
};

export default YesNoAnswer;
